import { useEffect } from "react";

import "../LegalInformationPages.css";

const TermsOfService = () => {
  const wrapper = document.querySelector(".landing-wrapper");

  useEffect(() => {
    wrapper?.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-information-container text-black xs:px-[24px] xs:py-[70px] xs:pt-[64px] sm:px-[95px] sm:py-[95px] sm:pt-[130px] md:px-[139px] md:py-[120px] md:pt-[140px] lg:px-[317px] lg:py-[165px] lg:pt-[214px]">
      <h1 className="mx-auto mb-2 text-center text-lg font-semibold uppercase tracking-wider text-primary-700 underline xs:mt-[60px] sm:mt-[80px] sm:leading-normal md:mt-[50px] lg:mt-0">
        WaiverKing
      </h1>
      <h2 className="mx-auto mb-2 text-center text-lg font-semibold uppercase tracking-wider text-primary-700 underline xs:mt-[60px] sm:mt-[80px] sm:leading-normal md:mt-[50px] lg:mt-0">
        Terms of Service
      </h2>
      <h3 className="mx-auto mb-2 text-center font-semibold uppercase text-primary-700 xs:mt-[60px] sm:mt-[80px] sm:leading-normal md:mt-[50px] lg:mt-0">
        PLEASE NOTE THE TERMS OF SERVICE MAY HAVE CHANGED.
      </h3>
      <h4 className="mx-auto mb-6 text-center font-semibold text-primary-700 xs:mt-[60px] sm:mt-[80px] sm:leading-normal md:mt-[50px] lg:mt-0">
        Effective Date (Date of Last Update):{" "}
        <span className="underline">16 July 2025</span>
      </h4>
      <p>
        When you use our website, product, and services, you are agreeing to our
        terms of service, so please be sure to read them carefully as they
        contain important information regarding your legal rights and
        obligations.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          1. <u>Introduction.</u>
        </strong>{" "}
        These Terms of Service apply to all Websites controlled by WaiverKing,
        Inc. (<strong>"WaiverKing"</strong>). <strong>"Websites"</strong>{" "}
        include sites hosted by one or more web servers (however accessed and/or
        used, whether via personal computers, mobile devices, or otherwise
        (collectively, <strong>"Computer"</strong>)), and other interactive
        features, applications, software, or downloads that are operated by
        WaiverKing and that are available through, or interact with, the
        Websites where these Terms of Service are posted (the{" "}
        <strong>"Services"</strong>).{" "}
        <u>
          This includes all WaiverKing services governed by the WaiverKing
          Subscription Agreement.
        </u>{" "}
        These Terms of Service apply to any use of the Websites and Services,
        whether in connection with a paid subscription or a free trial.
      </p>
      <p>&nbsp;</p>
      <p>
        These Terms of Service apply to any use of and access to the Websites or
        Services by you and your Affiliates. By accessing or using the Websites
        or Services (or enabling an Affiliate to access or use the Websites or
        Services), you are indicating that you have read these Terms of Service
        and agree to be bound by its terms. If you do not agree with all of the
        terms, you may not access or use the Websites or any Services.
      </p>
      <p>&nbsp;</p>
      <p>
        These Terms of Service are a binding legal agreement between you and
        WaiverKing. If you enter into this Agreement on behalf of a company or
        other legal entity, you represent and warrant that you have the legal
        authority to bind that entity and its Affiliates to this Agreement, and
        all references to "you" and "your" in this Agreement are referring to
        that entity.
      </p>
      <p>&nbsp;</p>
      <p>
        You agree that these Terms of Service are supported by good and valuable
        consideration the receipt and sufficiency of which you hereby
        acknowledge. Such consideration includes, without limitation, your use
        of the Websites, the materials and information available. In addition to
        these Terms of Service, WaiverKing has established a Privacy Policy to
        explain how personal information and data from both a Business Client
        and End User is or may be collected and used by WaiverKing. Please
        review the Privacy Policy carefully, as by using our website and
        services, you may be agreeing to allow us to collect some personal
        information and data about you.
      </p>
      <p>&nbsp;</p>
      <p>
        <p>
          <strong>Consent to SMS Messages:</strong>
        </p>
        By requesting an OTP (One-Time Password) via SMS, you explicitly consent
        to receive authentication messages from WaiverKing at the mobile phone
        number provided. Message frequency may vary depending on authentication
        requests. Standard messaging and data rates from your mobile carrier may
        apply. You may opt-out of receiving SMS OTP messages at any time by
        replying STOP. For additional assistance, reply HELP or contact customer
        support directly.
      </p>
      <p>&nbsp;</p>
      <p>
        You must be at least eighteen (18) years old to have WaiverKing's
        permission to use the Websites and/or Services. If you are between the
        ages of thirteen (13) and seventeen (17), or under the age of majority
        where you live, you represent that your parent or legal guardian has
        reviewed and agreed to these Terms of Service.{" "}
        <strong>
          <u>
            If you are under the age of thirteen (13) years old, you do not have
            permission to use our Websites or Services.
          </u>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p>
        THE WEBSITES AND RELATED SERVICES, APPLICATIONS, AND FEATURES PROVIDED
        BY WAIVERKING ARE PROVIDED SUBJECT TO YOUR COMPLIANCE WITH THE TERMS OF
        SERVICE SET FORTH BELOW. PLEASE READ THE FOLLOWING INFORMATION CAREFULLY
        AS THEY AFFECT YOUR LEGAL RIGHTS AND OBLIGATIONS. YOUR CONTINUED USE OF
        THE WEBSITES OR SERVICES WILL INDICATE YOUR WILLINGNESS TO BE BOUND BY
        THESE TERMS OF SERVICE, WHICH MAY CHANGE FROM TIME TO TIME. THESE TERMS
        OF SERVICE GRANT WAIVERKING, INC. CERTAIN RIGHTS AND LICENSES, PROVIDE
        WAIVERKING, INC. CERTAIN INDEMNITIES, WAIVE CERTAIN OF YOUR RIGHTS AND
        REMEDIES, AND LIMIT WAIVERKING, INC.'S LIABILITY AND OBLIGATIONS TO YOU.
        IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS OF SERVICE, PROMPTLY EXIT
        THE WEBSITES AND DO NOT USE THE SERVICES, APPLICATIONS, AND OTHER
        FEATURES PROVIDED BY WAIVERKING AVAILABLE ON THE WEBSITES OR OFFERED BY
        WAIVERKING IN ANY OTHER FORMAT.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing may, in its sole discretion, make changes to the Terms of
        Service from time to time. Any changes made will become effective when a
        modified version of the Terms of Service are posted to the Websites and
        Services. If there any material changes to the Terms of Service,
        WaiverKing will also notify you within the Services or by sending you an
        email. If you continue using the Websites and Services after any
        changes, it means you have accepted them. If you do not agree to any
        changes, you must stop using the Services, and you can terminate your
        account by following the account termination procedures. It is your
        obligation to ensure that you read, understand, and agree to the latest
        version of the Terms of Service. The legend at the top of the Terms of
        Service indicates when it was last changed.
      </p>
      <p>&nbsp;</p>
      <p>
        Your use of, and participation in, certain Services may be subject to
        additional terms (<strong>"Supplemental Terms"</strong>) and such
        Supplemental Terms will either be listed in these Terms of Service or
        will be presented to you for your acceptance when you sign up to use the
        supplemental Services. If these Terms of Service are inconsistent with
        the Supplemental Terms, the Supplemental Terms will control with respect
        to the supplemental Service with which they apply.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          2. <u>Services.</u>
        </strong>{" "}
        WaiverKing will make the Services to which you have subscribed available
        to you, subject to the terms and conditions of these Terms of Service
        and any Supplemental terms. During the Subscription Term (defined
        below), the Services will meet the service levels provided below.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing will take all commercially reasonable steps to ensure that
        the Websites and Services available to you on a twenty-four (24) hour,
        seven (7) days a week basis.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing will make updates to the Websites and software for the
        Services from time to time, but for the majority of these updates, no
        downtime for the Websites or Services will be required. A refresh of the
        Websites and software by the user may be required after an update. If,
        in the rare instance or occasion, an update requires a complete and
        temporary shut-down of the Websites, software, and Services, WaiverKing
        will make all commercially reasonable efforts to ensure such downtimes
        are quickly resolved, in most cases, excluding any unforeseen problems
        or errors, with resolution and access to the Websites and Services
        within thirty (30) minutes. WaiverKing will make all commercially
        reasonable efforts to ensure that any planned updates requiring downtime
        of the Websites, software, or Services are scheduled during off-hours to
        minimize the impact of any downtime on you. When possible, WaiverKing
        will give you notice before any downtime from a scheduled update to
        allow you to plan accordingly.
      </p>
      <p>&nbsp;</p>
      <p>
        Notwithstanding the above, in addition to other rights set forth in
        these Terms of Service, WaiverKing reserves the right to suspend any
        Websites or Services (1) in connection with a Force Majeure event, (2)
        if WaiverKing believes, in its sole discretion, any malicious software
        is being used in connection with your account, or (3) during planned
        downtime. In addition, WaiverKing reserves the right to change, suspend,
        or discontinue any features, components, or functions of the Services at
        any time. If WaiverKing makes any material changes to the Services,
        WaiverKing will notify you within the Services or by sending you an
        email. Notwithstanding the above, WaiverKing has no obligation to update
        or enhance any Services or to produce or release new versions of any
        Services.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing will not be liable for any failure or delay in performance
        under these Terms of Service (other than for delay in the payment of
        money due and payable hereunder) for causes beyond WaiverKing's
        reasonable control and occurring without WaiverKing's fault or
        negligence, including, but not limited to, acts of God, acts of
        government, flood, fire, pandemic, civil unrest, acts of terror, strikes
        or other labor problems (other than those involving WaiverKing's or your
        employees, respectively), or computer attacks (by government/nation
        entities or otherwise) or malicious acts, such as attacks on or through
        the Internet, any Internet service provider, telecommunications or
        hosting facility. Dates by which performance obligations are scheduled
        to be met will be extended for a period of time equal to the time lost
        due to any delay so caused.
      </p>
      <p>&nbsp;</p>
      <p>
        Although the Services may allow you to access or use third-party
        offerings, they are not Services under these Terms of Service and are
        not subject to any of the warranties, service commitments, or other
        obligations with respect to Services hereunder. The availability of any
        third-party offerings through the Services does not imply WaiverKing's
        endorsement of or affiliation with the provider. WaiverKing does not
        control third-party offerings and will have no liability to you or
        Affiliates in connection with any third-party offerings. WaiverKing has
        no obligation to monitor or maintain third-party offerings and may
        disable or restrict access to any third-party offerings at any time. By
        using or enabling any third-party offerings, you are expressly
        permitting WaiverKing to disclose your personal information and data or
        other information to the extent necessary to utilize the third-party
        offerings. YOUR USE OF THIRD-PARTY OFFERINGS IS AT YOUR OWN RISK AND IS
        SUBJECT TO ANY ADDITIONAL TERMS, CONDITIONS. AND POLICIES APPLICABLE TO
        SUCH THIRD-PARTY OFFERINGS (SUCH AS TERMS OF SERVICE OR PRIVACY POLICIES
        OF THE PROVIDERS OF SUCH THIRD PARTY OFFERINGS).
      </p>
      <p>&nbsp;</p>
      <p>
        Additional terms specific to the procurement of Professional Services
        apply and are hereby incorporated by reference into these Terms of
        Service as if set forth fully herein. WaiverKing shall provide the
        services to you as described in a fully executed Statement of Work (
        <strong>"SOW"</strong>) (the <strong>"Professional Services"</strong>)
        in accordance with these Terms of Service. You agree that your purchase
        of Professional Services is not contingent on the delivery of any future
        service software functionality or features or on any oral or written
        public comments by us regarding future software functionality or
        features.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          3. <u>Access and Use.</u>
        </strong>{" "}
        When using the Websites and Services, you agree to comply with all
        applicable U.S. federal, state, and local laws, regulations, statutes,
        regulations, and the like. The Websites and Services are protected by
        U.S. federal and state copyright and trademark laws. No portion of the
        materials on the Websites and Services may be reprinted, copied,
        republished, modified, used to create derivative works, publicly
        displayed, published, transmitted, distributed, or otherwise exploited
        in any form without the express written permission of WaiverKing and/or
        the respective owner of any third-party content. You shall keep intact
        and not remove, alter, cover, or distort any proprietary notices,
        including copyright or trademark notices, contained on any downloaded
        materials and shall comply with any applicable end user license
        agreements.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <em>Restrictions on Use.</em>
        </strong>{" "}
        You, and anyone that you have use the Websites and Services, will not:
        (1) submit any infringing, obscene, defamatory, threatening, or
        otherwise unlawful or tortious material to the Services, including
        material that violates privacy rights; (2) interfere with or disrupt the
        integrity or performance of the Services or the data contained therein;
        (3) attempt to gain access to the Services or related systems or
        networks in a manner not permitted by these Terms of Service; (4) post,
        transmit, or otherwise make available through or in connection with the
        Services any virus, worm, Trojan horse, Easter egg, time bomb, spyware
        or other harmful computer code, files, scripts agents, or programs; (5)
        restrict or inhibit any other person or entity from using the Services;
        (6) remove any copyright, trademark, or other proprietary rights notice
        from the Services; (7) frame or mirror any portion of the Services, or
        otherwise incorporate any portion of the Services into any product or
        service; (8) systematically download and store Services content; (9) use
        the Services to send unsolicited electronic messages (aka spamming); or
        (10) use any robot, spider, site search/retrieval application, or other
        manual or automatic device to retrieve, index, "scrape," "data mine," or
        otherwise gather Services content, or reproduce or circumvent the
        navigational structure or presentation of the Services.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing grants you a limited right to use the Websites and Services
        on an authorized device. The Websites and Services may not be downloaded
        to or exported or re-exported to a country that is subject to a U.S.
        Government embargo, or that has been designated by the U.S. Government
        as a "terrorist supporting" country, or to any prohibited or restricted
        country, person, end-user, or entity specified by federal or state laws.
        Additionally, you may not:
      </p>
      <p>&nbsp;</p>
      <ol className="legal-text__list">
        <li>
          disable or otherwise interfere with the Websites' or Services'
          security-related features;
        </li>
        <li>
          collect or harvest any personal information or data from the Websites
          and/ or Services (e.g., user names, passwords, mail addresses, etc.);
        </li>
        <li>
          solicit other users to join or become members of any commercial
          service or organization without WaiverKing's prior written approval;
        </li>
        <li>
          attempt to or interfere with, impair, or disable the proper working of
          the Websites or Services;
        </li>
        <li>
          decompile, reverse engineer, disassemble, or modify any website or
          service source or object code, software, other products, services, or
          processes accessible through any portion of the Websites or Services;
        </li>
        <li>make and/or distribute copies of the Websites or Services;</li>
        <li>use network-monitoring software;</li>
        <li>
          encourage conduct that violates any local, state, or federal law or
          impersonate another user, person, or entity;
        </li>
        <li>
          use the Website and Service Content in a manner that suggests an
          association with any of WaiverKing's products, services, or brands; or
        </li>
        <li>
          engage in any conduct that restricts or inhibits any other user from
          using or enjoying the Websites and/or Services.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>
          <em>Business Liability for Affiliates and End-Users.</em>
        </strong>{" "}
        Business clients are responsible for all activity occurring under or
        relating to their account, including, but not limited to, their staff,
        employees, consultants, advisors, independent contractors, and End
        Users. Business clients will ensure that their Affiliates and End Users
        comply with relevant provisions of these Terms of Service, including any
        Supplemental Terms and acceptable use policies provided or made
        available by WaiverKing, and any applicable local, state, national, and
        foreign laws, including those related to data privacy and transmission
        of personal data, at all times while using the Services. Any reference
        in these Terms of Service to "access" or "use" of Services (or similar
        phrase) is deemed to include access or use, as appropriate, by
        Affiliates and/or End Users, and any act or omission of an Affiliate or
        End User that does not comply with these Terms of Service will be deemed
        a breach of these Terms of Service by the business client. The business
        client is also responsible for ensuring that they have the appropriate
        rights to interact and/or contact End Users through the Services, as
        applicable, in accordance with applicable laws and regulations.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          4. <u>Fees and Payment.</u>
        </strong>{" "}
        Unless otherwise stated on an order form, fees for the Services (
        <strong>"Subscription Fees"</strong>) are set forth on the applicable
        Website(s). Unless otherwise specified, the Subscription Fees during a
        Renewal Term (defined below) will be updated to the pricing set forth on
        the applicable Website when each Renewal Term begins. If you have an
        order form, WaiverKing may increase any fees specified in an order form,
        provided the increase will not become effective until the subsequent
        Renewal Term. Prices are subject to change for those Services you have
        elected not to purchase or that are otherwise not identified in an order
        form. WaiverKing may also convert any free, trial, or beta Service into
        a Service subject to a Subscription Fee upon notice to you, and your
        rights to such Service will be suspended if you do not pay the
        Subscription Fee.
      </p>
      <p>&nbsp;</p>
      <p>
        You agree to pay the Subscription Fees and any other applicable fees
        stated on an order form or otherwise specified in these Terms of
        Service. YOU ARE RESPONSIBLE FOR ALL SUBSCRIPTION FEES FOR THE ENTIRE
        SUBSCRIPTION TERM. All payment obligations under this Agreement are
        non-cancelable and all fees paid are non-refundable. Unless otherwise
        stated on an order form, fees must be paid in advance of each billing
        period. You will provide WaiverKing with valid and updated credit card
        information or another form of payment acceptable to WaiverKing. If you
        provide credit card information, you represent that you are authorized
        to use the card and you authorize WaiverKing to charge the card for all
        payments hereunder. By submitting payment information, you authorize
        WaiverKing to provide that information to third-parties for purposes of
        facilitating payment. You agree to verify any information requested by
        WaiverKing for purposes of acknowledging or completing any payment.
      </p>
      <p>&nbsp;</p>
      <p>
        If you believe a payment has been processed in error, you must provide
        written notice to WaiverKing within 30 days after the date of payment
        specifying the nature of the error and the amount in dispute (
        <strong>"Payment Error Notice"</strong>). If the Payment Error Notice is
        not received by WaiverKing within such 30 day period, the payment will
        be deemed final.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          5. <u>Intellectual Property Notice.</u>
        </strong>{" "}
        Unless otherwise explicitly specified, the Websites, Services, and
        included content (and any derivative works or enhancements of the same),
        including, but not limited to, all layouts, texts, illustrations,
        instructions, files, images, designs, software, scripts, graphics,
        photos, sounds, music, videos, information, content, materials,
        products, services, URLs, advertising copy, technology, documentation,
        interactive features, the compilation, assembly, and arrangement of the
        materials of the Websites and Services, and any and all copyrightable
        material (including source and object code) (collectively, the{" "}
        <strong>"Website and Service Content"</strong>) and all intellectual
        property rights to the same are owned or controlled by WaiverKing,
        WaiverKing's licensors, or both. Additionally, all trademarks, service
        marks, trade names, trade identities, and trade dress that may appear on
        the Websites and Services are owned by WaiverKing, WaiverKing's
        licensors, or both. Except for the limited use rights granted to you in
        these Terms of Service, you shall not acquire any right, title, or
        interest in the Websites, Services, or any Website and Service Content.
        Any rights or remedies not expressly granted in these Terms of Service
        are expressly reserved.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          6. <u>Confidential and Proprietary Information.</u>
        </strong>{" "}
        WaiverKing does not want to receive confidential or proprietary
        information from you through the Websites or Services. Please note that
        any information or material sent to WaiverKing through the Websites or
        Services will be deemed NOT confidential. By sending WaiverKing any
        information or material, you grant WaiverKing an unrestricted,
        irrevocable, world-wide, royalty-free license to use, reproduce,
        display, perform, modify, transmit, and distribute those materials or
        information, and you also agree that WaiverKing is free to use any
        ideas, concepts, know-how, or techniques that you send WaiverKing for
        any purpose.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          7. <u>User Content.</u>
        </strong>{" "}
        WaiverKing may now or in the future permit Subscription Users to post,
        upload, display, publish, distribute, transmit through, broadcast, or
        otherwise make available on the Websites messages, text, illustrations,
        files, images, graphics, photos, comments, sounds, music, videos,
        information, content, posts, and/or other materials (
        <strong>"Subscription User Content"</strong>).
      </p>
      <p>&nbsp;</p>
      <p>
        By posting content to the Websites, you warrant and represent that you
        either own or otherwise control all of the rights to that content,
        including, without limitation, all the rights necessary for you to
        provide, post, upload, input, or submit the content or that your use of
        the content is a protected fair use. You agree that you will not
        knowingly and with intent to defraud provide material and misleading
        false information. You represent and warrant also that the content you
        supply does not violate these Terms of Service. It is your sole
        responsibility to ensure that your postings do not disclose confidential
        and/or proprietary information, including information covered by a
        nondisclosure agreement, that you are not authorized to disclose.
      </p>
      <p>&nbsp;</p>
      <p>
        You represent, warrant, and covenant that you will not submit any
        Subscription User Content that: (i) violates or infringes in any way the
        rights of others, including, but not limited to, any copyright,
        trademark, patent, trade secret, moral right, or other intellectual
        property, personal, contractual, proprietary, or other third party right
        of any person or entity; (ii) impersonates another or is unlawful,
        threatening, abusive, libelous, defamatory, invasive of privacy or
        publicity rights, vulgar, obscene, profane, pornographic, lewd,
        excessively violent, harassing, or otherwise objectionable; (iii)
        encourages conduct that would constitute a criminal offense or otherwise
        violate any law; (iv) is an advertisement for goods or services or a
        solicitation of funds; (v) includes personal information such as
        messages which identify phone numbers, social security numbers, account
        numbers, or addresses; (vi) contains a formula, instruction, or advice
        that could cause harm or injury; (vii) is a chain letter of any kind;
        (viii) depicts any third party trademarks or products or services in any
        manner that violates their rights or could otherwise create liability;
        or (ix) violates these Terms of Service.
      </p>
      <p>&nbsp;</p>
      <p>
        By posting your Subscription User Content using the Websites or
        Services, you are granting an unrestricted, unlimited, irrevocable,
        non-exclusive, royalty-free, perpetual, worldwide, and fully
        transferable, assignable, and sub-licensable right and license to use,
        copy, reproduce, disclose, sell, sublicense, lease, reproduce, modify,
        adapt, publish, translate, create collective or derivative works from,
        distribute, perform, display, and otherwise exploit your Subscription
        User Content in whole or in part and to incorporate it in other works in
        any form, media, or technology now known or later developed by
        WaiverKing. You also grant other users permission to access your
        Subscription User Content and to use, copy, reproduce, disclose, sell,
        sublicense, lease, reproduce, modify, adapt, publish, translate, create
        collective or derivative works from, distribute, perform, display, and
        otherwise exploit your Subscription User Content for personal,
        non-commercial use as permitted by the functionality of the Websites and
        these Terms of Service. You agree that your Subscription User Content
        will be treated as non-confidential and non-proprietary as discussed
        above.
      </p>
      <p>&nbsp;</p>
      <p>
        By submitting Subscription User Content, you also grant WaiverKing the
        right, but not the obligation to use your biographical information,
        including, without limitation, your name and geographical location in
        connection with broadcast, print, online, or other use or publication of
        your Subscription User Content. Notwithstanding the foregoing, you
        further warrant that all so-called moral rights in the Subscription User
        Content have been waived.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          WaiverKing cautions you not to disclose personal information about
          yourself or your children, such as social security numbers, credit
          card numbers, etc.
        </strong>
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing has the right, but not the obligation, to monitor
        Subscription User Content. WaiverKing has no obligation to post,
        maintain, accept, display, exploit, or otherwise make use of
        Subscription User Content and does not guarantee distribution of
        Subscription User Content. Subscription User Content will not be
        returned, and you will not have the right, once posted, to access,
        archive, maintain, or otherwise use such Subscription User Content on
        the Websites. WaiverKing may discontinue operation of the Websites or
        your use of the Websites, in either case in whole or in part, in
        WaiverKing's sole discretion. WaiverKing may, in WaiverKing's sole
        discretion, delete, move, reformat, edit, alter, distort, remove, or
        refuse to exploit Subscription User Content without notice or liability;
        provided, however, that WaiverKing reserves the right to treat
        Subscription User Content on the Websites, or on certain portions of the
        Websites, as content stored at the direction of users for which
        WaiverKing will not exercise editorial control except to block or remove
        content that is obscene, lewd, violent, harassing, or otherwise
        objectionable or to enforce the rights of third parties.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          8. <u>Data Ownership.</u>
        </strong>{" "}
        All right, title, and interest in any data or information collected by
        WaiverKing independently and without access to, reference to or use of
        any of your data, will be solely owned by WaiverKing (collectively,
        "WaiverKing Data").
      </p>
      <p>&nbsp;</p>
      <p>
        You agree WaiverKing owns all Aggregated Data. You also agree that
        nothing in these Terms of Service will prohibit WaiverKing or its
        affiliates from utilizing Aggregated Data for any purpose, provided such
        Aggregated Data does not reveal any personally identifying information
        about you or is reasonably linkable to any End User or household.
      </p>
      <p>&nbsp;</p>
      <p>
        WaiverKing's Privacy Policy governs how WaiverKing collects and uses
        personal information and data that is submitted through the Services. By
        accessing or using the Services, you agree that you have read and accept
        the WaiverKing Privacy Policy. Without limitation, you acknowledge and
        agree that WaiverKing may process your data for the purpose of providing
        the Services and related functions, such as billing and customer or End
        User support, as well as to send direct marketing communications, data
        science, and product or service improvement and reporting. You represent
        and warrant that you are authorized to process your data and make such
        data available to WaiverKing for uses as set out in these Terms of
        Service and the Privacy Policy, including through appropriate notice and
        consent by you referring all individuals using our Services to our
        Privacy Policy.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <em>HIPAA.</em>
        </strong>{" "}
        The Health Insurance Portability and Accountability Act of 1996 (
        <strong>"HIPAA"</strong>) imposes rules to protect certain personal
        health information or <strong>"PHI"</strong> as that term is defined
        under HIPAA. If you or any Affiliate is subject to HIPAA and providing
        or processing any PHI in connection with the Services, prior to
        accessing or using the Services you must notify WaiverKing and enter
        into a Business Associate Agreement (<strong>"BAA"</strong>) in the form
        provided by WaiverKing. You are solely responsible for determining
        whether you or any Affiliates are subject to HIPAA.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          9. <u>Subscription User Registration.</u>
        </strong>{" "}
        In order to access or use some (or potentially all) of the features of
        the Websites and Services, you may have to create an account and become
        a registered user. To become a registered user, you must provide true,
        accurate, current, and complete registration information about you as
        may be prompted by any registration forms and, if such information
        changes, you will promptly update the relevant registration information.
        During registration, you may be required to create a username and
        password (a <strong>"Membership"</strong>), which may permit you access
        to certain areas of the Websites not available to non-registered users.
        You are responsible for safeguarding and maintaining the confidentiality
        of your Membership and for restricting access to your Computer so that
        others may not access any password protected portion of the Websites and
        Services using your username in whole or in part. If you register with
        WaiverKing, you agree to accept sole responsibility for all activities
        that occur under your Membership, whether or not you have authorized the
        activity. You agree you will not sell, transfer, or assign your
        Membership or any Membership rights. You agree to notify WaiverKing
        immediately at admin@waiverking.com of any breach of security or
        unauthorized use of your Membership. You may terminate your Membership
        at any time by sending an email to accounts@waiverking.com.{" "}
        <strong>
          WaiverKing reserves the right to terminate your account or otherwise
          deny you access to the Websites in WaiverKing's sole discretion for
          any or no reason without notice and without liability.
        </strong>
      </p>
      <p>&nbsp;</p>
      <p>
        You are responsible for any costs or fees incurred or associated with
        your Membership, as are applicable. You will be notified of what fees or
        charges you may be liable for before incurring such costs or fees.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          10. <u>Children.</u>
        </strong>{" "}
        Collecting personal information from children under the age of 13
        (singularly a <strong>"Minor Child"</strong> and plural as{" "}
        <strong>"Minor Children"</strong>) through the Websites and Services is
        prohibited. No Subscription User Content should be directed toward Minor
        Children.{" "}
        <u>
          Minor Children, or anyone under the age of 13 years old, are not
          eligible to use the Websites and Services
        </u>
        , and WaiverKing asks that they do not submit any personal information
        and data to WaiverKing.
      </p>
      <p>&nbsp;</p>
      <p>
        To create an account with us through the Websites or Services, you must
        be over the age of sixteen (16). Children under the age of sixteen (16)
        will not be allowed to create an account or input their own personal
        information or data, as our system will not allow an account to be
        created for a user when the birthdate submitted by that user shows an
        age younger than sixteen (16) years old. Children under the age of
        sixteen (16) will need their parent or legal guardian to create an
        account and input personal information and data on their behalf; they
        may also require their parent or legal guardian to sign or consent to
        any waivers.
      </p>
      <p>&nbsp;</p>
      <p>
        In the event that a parent or legal guardian voluntarily submits his,
        her, or their Minor Child or Minor Children's personal information and
        data through the Websites or Services, WaiverKing will create a profile
        linking the Minor Child dependent to the parent or legal guardian.
        Parents or legal guardians acknowledge that their Minor Child or Minor
        Children's personal information and data will therefore be collected and
        that all other provisions of this Terms of Service Agreement and any and
        all policies incorporated herein by reference apply to their Minor Child
        or Minor Children. WaiverKing is not responsible for the entry of a
        Minor Child's personal information and data.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          11. <u>Third-Party Websites.</u>
        </strong>{" "}
        WaiverKing may provide third-party content on the Sites (including
        embedded content) or links to third-party web pages, content,
        applications, products, and services, including advertisements and
        promotions (collectively, <strong>"Third-Party Content"</strong>) as a
        service to those interested in this information. WaiverKing does not
        control, endorse, or adopt any Third-Party Content, including that the
        inclusion of any link does not imply affiliation, endorsement, or
        adoption by WaiverKing of any site or any information contained therein,
        and can make no guarantee as to its accuracy or completeness. The
        Websites, all content and services provided on the Websites, and all
        information you obtain through the Websites and Services are provided on
        an "as is" and "as available" basis. WaiverKing makes no representations
        whatsoever about any Third-Party Content that you may access though the
        Websites or Service, or the Third-Party Content information you may
        obtain through the Websites or Services. When you access a
        non-WaiverKing website or are provided with information from a
        non-WaiverKing website, please understand that it is independent from
        WaiverKing, and that WaiverKing has no control over the content,
        accuracy, timeliness, or completeness of information on that website. In
        addition, a hyperlink to a non-WaiverKing website does not mean that
        WaiverKing endorses or accepts any responsibility for the content, or
        the use, of the linked site. It is up to you to take precautions to
        ensure that whatever you select for your use or download is free of such
        items as viruses, worms, trojan horses, and other items of a destructive
        nature. You should refer to the separate terms of use, privacy policies,
        and other rules posted on non-WaiverKing websites before you use them.
        You agree not to create a link from any website, including any website
        controlled by you, to the Websites.
      </p>
      <p>&nbsp;</p>
      <p>
        You acknowledge and agree that WaiverKing is not responsible or liable
        in any manner for any Third-Party Content and undertakes no
        responsibility to update or review such Third-Party Content. You agree
        to use such Third-Party Content contained therein at your own risk. When
        you visit other sites via Third-Party Content, or participate in
        promotions or business dealings with third parties, you should
        understand that our terms and policies no longer govern, and that the
        terms and policies of those third-party sites will now apply. You should
        review the applicable terms and policies, including privacy and data
        gathering practices, of any site to which you navigate from our Sites.
        You must comply with any applicable third-party terms when using the
        Sites.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          12. <u>Warranty Disclaimer & General Disclaimers.</u>
        </strong>{" "}
        THE WEBSITES AND SERVICES, INCLUDING ANY CONTENT OR INFORMATION
        CONTAINED WITHIN IT OR ANY WEBSITE-RELATED SERVICE, ARE PROVIDED "AS
        IS," WITH ALL FAULTS, WITH NO REPRESENTATIONS OR WARRANTIES OF ANY KIND,
        EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
        NON-INFRINGEMENT, WARRANTIES THAT THE WEBSITES OR SERVICES WILL MEET
        YOUR REQUIREMENTS, WARRANTIES CONCERNING THE AVAILABILITY, ACCURACY,
        SECURITY, OR INFORMATION CONTENT ON THE WEBSITES OR ON THE SERVICES,
        WARRANTIES FOR SERVICES OR GOODS RECEIVED THROUGH OR ADVISED ON THE
        WEBSITES OR THROUGH THE SERVICES, WARRANTIES CONCERNING THE ACCURACY OR
        RELIABILITY OF THE RESULTS THAT MAY BE OBTAINED THROUGH USE, AND
        WARRANTIES THAT THE WEBSITES WILL BE SECURE OR ERROR-FREE. YOU ASSUME
        TOTAL RESPONSIBILITY AND RISK FOR YOUR USE OF THE WEBSITES,
        WEBSITE-RELATED SERVICES, SERVICES, AND HYPERLINKED WEBSITES.
      </p>
      <p>&nbsp;</p>
      <p>
        YOU UNDERSTAND THAT ALL SUBSCRIPTION USER CONTENT POSTED TO THE WEBSITES
        IS THE SOLE RESPONSIBILITY OF THE INDIVIDUAL WHO ORIGINALLY POSTED THE
        CONTENT. YOU UNDERSTAND, ALSO, THAT ALL OPINIONS EXPRESSED BY SUBSCRTION
        OR END USERS OF THE WEBSITES OR SERVICES ARE EXPRESSED STRICTLY IN THEIR
        INDIVIDUAL CAPACITIES, AND NOT AS WAIVERKING, INC.'S REPRESENTATIVES OR
        ANY OF WAIVERKING, INC.'S SPONSORS OR PARTNERS. THE OPINIONS THAT YOU OR
        OTHERS POST ON THE WEBSITES OR SERVICES DO NOT NECESSARILY REFLECT
        WAIVERKING, INC.'S OPINIONS. IN ALL INSTANCES, IT IS YOUR RESPONSIBILITY
        TO EVALUATE THE ACCURACY, TIMELINESS, COMPLETENESS, OR USEFULNESS OF THE
        WEBSITE OR SERVICE CONTENT. UNDER NO CIRCUMSTANCE WILL WAIVERKING, INC.
        BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY YOUR RELIANCE ON ANY WEBSITE
        OR SERVICES CONTENT.
      </p>
      <p>&nbsp;</p>
      <p>
        WAIVERKING, INC., AND ITS AFFILIATES ARE NEITHER RESPONSIBLE NOR LIABLE
        FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY,
        PUNITIVE, OR OTHER DAMAGES (EVEN IF FORESEEABLE OR IF WAIVERKING, INC.
        HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES) UNDER ANY CONTRACT,
        NEGLIGENCE, STRICT LIABILITY, TORT, OR OTHER THEORY, ARISING OUT OF,
        RELATING TO, OR IN ANY WAY CONNECTED WITH THE WEBSITES, THE SERVICES,
        THESE TERMS OF SERVICE, AND/OR WEBSITE-RELATED SERVICES, CONTENT, OR
        INFORMATION CONTAINED WITHIN THE WEBSITES OR SERVICES. YOUR SOLE REMEDY
        FOR DISSATISFACTION WITH THE WEBSITES, SERVICES, WEBSITE-RELATED
        SERVICES, AND/OR HYPERLINKED WEBSITES IS TO STOP USING THE WEBSITES
        AND/OR THOSE SERVICES.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          13. <u>Indemnification.</u>
        </strong>{" "}
        You are solely liable for any damage resulting from your failure to
        obtain such permission or from any other harm resulting from
        Subscription User Content that you submit or Third-Party Content that is
        submitted on your behalf. You agree to indemnify and hold WaiverKing and
        its affiliated companies, and their directors, officers, employees,
        agents, and partners harmless from any and all claims or demands,
        including reasonable attorneys' fees and costs, that arise from or
        otherwise relate to (i) your access to or use of the Websites and/or
        Services; (ii) Subscription User Content provided by you, Third-Party
        Content, or through use of the Websites or Services; (iii) any actual or
        alleged violation or breach by you of these Terms of Service; (iv) any
        actual or alleged breach of any representation, warranty, or covenant
        that you have made to WaiverKing; or (v) your acts or omissions. You
        agree to cooperate fully with WaiverKing in the defense of any claim
        that is the subject of your obligations hereunder.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          14. <u>Reporting Claims of Copyright Infringement.</u>
        </strong>{" "}
        WaiverKing takes claims of copyright infringement seriously. WaiverKing
        will respond to notices of alleged copyright infringement that comply
        with applicable law. If you believe any materials accessible on or from
        the Websites or Services infringe your copyright, you may request
        removal of those materials (or access to them) from the Websites or
        Services by submitting written notification to our Copyright Agent
        (designated below). In accordance with the Online Copyright Infringement
        Liability Limitation Act of the Digital Millennium Copyright Act (17
        U.S.C. § 512) ("DMCA"), the written notice (the "DMCA Notice") must
        include substantially the following:
      </p>
      <p>&nbsp;</p>
      <ul className="legal-text__list">
        <li>your physical or electronic signature;</li>
        <li>
          identification of the copyrighted work you believe to have been
          infringed or, if the claim involves multiple works on the Websites or
          Services, a representative list of such works;
        </li>
        <li>
          identification of the material you believe to be infringing in a
          sufficiently precise manner to allow WaiverKing to locate that
          material;
        </li>
        <li>
          adequate information by which WaiverKing can contact you (any website,
          including your name, postal address, telephone number and, if
          available, e-mail address);
        </li>
        <li>
          a statement that you have a good faith belief that use of the
          copyrighted material is not authorized by the copyright owner, its
          agent, or the law;
        </li>
        <li>
          a statement that the information in the written notice is accurate;
          and
        </li>
        <li>
          a statement, under penalty of perjury, that you are authorized to act
          on behalf of the copyright owner.
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        WaiverKing's designated Copyright Agent to receive DMCA Notices is:{" "}
        <span className="legal-text__link"> copyright@waiverking.com</span>
      </p>
      <p>&nbsp;</p>
      <p>
        If you fail to comply with all of the requirements of Section 512(c)(3)
        of the DMCA, your DMCA Notice may not be effective.
      </p>
      <p>&nbsp;</p>
      <p>
        Please be aware that if you knowingly materially misrepresent that
        material or activity on the Websites or Services is infringing your
        copyright, you may be held liable for damages (including costs and
        attorneys' fees) under Section 512(f) of the DMCA.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <em>Repeat Infringers.</em>
        </strong>{" "}
        It is WaiverKing's policy in appropriate circumstances to disable and/or
        terminate the accounts of users who are repeat infringers.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          15. <u>Choice of Law and Dispute Resolution.</u>
        </strong>{" "}
        These Terms of Service are entered into in the State of California and
        shall be governed by and construed in accordance with the laws of the
        State of California, exclusive of its choice of law rules.
      </p>
      <p>&nbsp;</p>
      <p>
        The parties agree that any controversy or claim arising out of or
        relating to these Terms of Service, or the breach thereof, will be
        settled by final, confidential, and binding arbitration in accordance
        with California Code of Civil Procedure Section 1280 et seq., and the
        then current rules and procedures of JAMS and before a single neutral
        arbitrator mutually selected by the parties. The arbitration shall be
        conducted in the English language.
      </p>
      <p>&nbsp;</p>
      <p>
        You and WaiverKing agree that each party may bring claims against the
        other only on an individual basis and not as a plaintiff or class member
        in any purported class or representative action or proceeding. The
        decision rendered by the arbitrator will be binding upon the parties
        hereto, and any judgment upon the award rendered by the arbitrator may
        be entered in any court having jurisdiction thereof. The parties consent
        to the exclusive jurisdiction of all federal and state courts in
        California. Venue will lie exclusively in Alameda County, California.
      </p>
      <p>&nbsp;</p>
      <p>
        For the sake of clarity, nothing in this paragraph shall affect
        WaiverKing's ability to seek from a court injunctive or equitable relief
        at any time. If a court finds any of these terms to be unenforceable or
        invalid, that term will be enforced to the fullest extent permitted by
        applicable law and the other terms will remain valid and enforceable.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          16. <u>Entire Agreement.</u>
        </strong>{" "}
        These Terms of Service constitute the entire agreement between
        WaiverKing and you pertaining to the subject matter of this agreement.
        In its sole discretion, WaiverKing may modify these Terms of Service by
        posting the revised version on the Websites and you agree that each
        visit by you to the Websites is a new transaction governed by the Terms
        of Service linked on the Websites at that time. When using any of the
        Services following an update to the Terms of Service, you may be asked
        to confirm that you have received, read, and agreed to the updated Terms
        of Service; even without such explicit acknowledgment, your continued
        use after an update to the Terms of Service will constitute agreement to
        the Terms of Service.
      </p>
      <p>&nbsp;</p>
      <p>
        Any delay or failure on the part of WaiverKing to exercise or enforce
        any rights under these Terms of Service to which WaiverKing may be
        entitled shall not, in any event, be construed as a waiver of the right
        and privilege to do so at any subsequent time. The section headings used
        herein are for convenience only and shall not be given any legal import.
      </p>
      <p>&nbsp;</p>
      <p>
        Updated or additional terms will be effective immediately upon notice,
        either by posting on the Websites so that they are accessible via a link
        on the homepage, by notification by e-mail, or by a notification when
        signing into an account on the Services. It is your responsibility to
        review the Terms of Service and the Websites from time to time for any
        updated or additional terms.
      </p>
      <p>&nbsp;</p>
      <p>
        If any provision of these Terms of Service are held by a court of
        competent jurisdiction to be contrary to law, the provision will be
        modified by the court and interpreted so as best to accomplish the
        objectives of the original provision to the fullest extent permitted by
        law, and the remaining provisions of these Terms of Service will remain
        in effect.
      </p>
      <p>&nbsp;</p>
      <p>
        You may not assign these Terms of Service or assign any rights or
        delegate any obligations hereunder, in whole or in part, without
        WaiverKing's prior written consent. Any such purported assignment or
        delegation by you without the appropriate prior written consent will be
        null and void and of no force and effect. WaiverKing may assign these
        Terms of Service or any rights hereunder without your consent and
        without notice.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          17. <u>No Unlawful or Prohibited Purpose.</u>
        </strong>{" "}
        As a condition of your use of the Websites, you warrant to WaiverKing
        that you will not use the Websites for any purpose that is unlawful or
        prohibited by these Terms of Service.
      </p>
    </div>
  );
};
export default TermsOfService;
